import { CurriculumDisicplineTypes } from "utils/constants";

// Cyclic disciplines have no semester and are saved per course.
export const isCourseScheduled = row => row?.type === CurriculumDisicplineTypes.Cyclic;
